import { getCookie, setCookie } from "../utils/cookies";
import { debug } from "./helpers";
import { trackNewSession } from "./segment";

const ANALYTICS_SESSION_COOKIE = "gdl-analytics-session";
const ANALYTICS_SESSION_EXPIRATION_MINUTES = 30;

// Every time we track a pageview or see some type of analytics event we want to extend our cookie so we know when the last activity took place.
// This means any activity that occurs within `ANALYTICS_SESSION_EXPIRATION_MINUTES` minutes
// will not result in a new session event. However, if `ANALYTICS_SESSION_EXPIRATION_MINUTES` minutes
// passes between activities, the event will be triggered. The goal is to resemble the behavior of "sessions" in hubspot. Now that
// we're on Salesforce, we're going to use segment track events to reflect the session behavior and pipeline into salesforce.
export function trackAnalyticsSession() {
  const currentExpiration = getCookie(ANALYTICS_SESSION_COOKIE);

  const isNewSession = currentExpiration == null || Number(currentExpiration) < Date.now();

  const expires = new Date();

  expires.setMinutes(expires.getMinutes() + ANALYTICS_SESSION_EXPIRATION_MINUTES);

  const analyticsSessionExpiration = expires.getTime();

  setCookie(ANALYTICS_SESSION_COOKIE, analyticsSessionExpiration, { expires });

  if (isNewSession) {
    debug("analytics", "Reporting new analytics session");

    trackNewSession();
  }
}
